import { gtm } from 'apps/gtm';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

export default ({ id, id2, text, creative, position, gtmPageType = gtmPageTypes.Other, sectionTitle }) => {
  gtm.trigger('gtm:promotionClick', {
    collectionFopIdx: position,
    gtmPageType,
    offer: {
      id,
      id2,
      text,
      creative,
    },
    section: {
      title: sectionTitle,
    },
  });
};
